module.exports = __webpack_public_path__ + "static/forgot-password-popup-1bcb330db847983419b81781ed057227.png";